/**
 * Parse message content and highlight @mentions
 * Returns an array of text and mention elements
 */
import React from 'react';

// Regex to match @firstname or @firstname_lastname
const MENTION_REGEX = /@(\w+(?:_\w+)?)/g;

/**
 * Parse text and return array of strings and React elements for mentions
 */
export const parseMentions = (text) => {
  if (!text) return [text];
  
  const parts = [];
  let lastIndex = 0;
  let match;
  
  // Reset regex lastIndex
  MENTION_REGEX.lastIndex = 0;
  
  while ((match = MENTION_REGEX.exec(text)) !== null) {
    // Add text before the mention
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    
    // Add the mention as a styled element
    const mentionText = match[0]; // @firstname_lastname
    const username = match[1]; // firstname_lastname
    
    parts.push({
      type: 'mention',
      text: mentionText,
      username: username
    });
    
    lastIndex = match.index + match[0].length;
  }
  
  // Add remaining text after last mention
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  
  return parts.length > 0 ? parts : [text];
};

/**
 * Render parsed content with styled mentions
 */
export const renderWithMentions = (text, currentUsername = null) => {
  const parts = parseMentions(text);
  
  return parts.map((part, index) => {
    if (typeof part === 'string') {
      return <span key={`txt-${index}`}>{part}</span>;
    }
    
    if (part.type === 'mention') {
      // Check if this mention is for the current user
      const isCurrentUser = currentUsername && 
        part.username.toLowerCase() === currentUsername.toLowerCase();
      
      return (
        <span
          key={`m-${index}-${part.username}`}
          className={`mention-highlight ${isCurrentUser ? 'mention-self' : ''}`}
          data-testid={`mention-${part.username}`}
        >
          {part.text}
        </span>
      );
    }
    
    return <span key={`p-${index}`}>{part}</span>;
  });
};

export default { parseMentions, renderWithMentions };
